import config from '@/config/config'
import TabbarLayout from '@/layout/TabbarLayout/index.vue'

/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
*/

const visitorMode = Boolean(process.env.VUE_APP_VISITOR_MODE)

const tabbar = [
	{
		path: '/tabbar',
		name: 'Tabbar',
		component: TabbarLayout,
		children: [
			{
				path: '/tabbar/home',
				name: 'Home',
				component: () => import('@/views/Home'),
				meta: {
					name: '首页',
					keepAlive: true,
					noLogin: config.visitorMode,
					routerBack: false
				},
				icon: {
					active: require('@/assets/Tabbar/achome.svg'),
					inactive: require('@/assets/Tabbar/home.svg')
				}
			},
			{
				path: '/tabbar/category',
				name: 'Category',
				component: () => import('@/views/cate'),
				meta: {
					name: '分类',
					keepAlive: true,
					noLogin: config.visitorMode,
					routerBack: false
				},
				redirect: { name: 'Model1' },
				icon: {
					active: require('@/assets/Tabbar/accategory.svg'),
					inactive: require('@/assets/Tabbar/category.svg')
				},
				children: [
					{
						path: '/tabbar/category/model1',
						name: 'Model1',
						component: () => import('@/views/cate/model1'),
						meta: {
							name: '分类1',
							keepAlive: true,
							noLogin: config.visitorMode,
							routerBack: false
						}
					},
					{
						path: '/tabbar/category/model2',
						name: 'Model2',
						component: () => import('@/views/cate/model2'),
						meta: {
							name: '分类2',
							keepAlive: true,
							noLogin: config.visitorMode,
							routerBack: false
						}
					},
					{
						path: '/tabbar/category/model3',
						name: 'Model3',
						component: () => import('@/views/cate/model3'),
						meta: {
							name: '分类3',
							tabShow: true,
							keepAlive: true,
							noLogin: config.visitorMode,
							routerBack: false
						}
					}
				]
			},
			// {
			// 	path: '/tabbar/cake',
			// 	name: 'Cake',
			// 	component: () => import('@/views/cake'),
			// 	meta: {
			// 		keepAlive: true,
			// 		routerBack: false,
			// 		name: '蛋糕',
			// 		tabShow: true
			// 	},
			// 	icon: {
			// 		active: require("@/assets/Tabbar/cake.svg"),
			// 		inactive: require("@/assets/Tabbar/cake.svg")
			// 	}
			// },
			// {
			//   path: '/gift',
			//   name: 'gift',
			//   component: () => import('@/views/gift'),
			//   meta: { name: '赠礼', tabShow: true },
			//   icon: {
			//     active: require("@/assets/Tabbar/acgift.svg"),
			//     inactive: require("@/assets/Tabbar/gift.svg")
			//   }
			// },
			{
				path: '/tabbar/car',
				name: 'Cart',
				component: () => import('@/views/car'),
				meta: { name: '购物车', tabShow: true, keepAlive: true, routerBack: false },
				icon: {
					active: require('@/assets/Tabbar/accar.svg'),
					inactive: require('@/assets/Tabbar/car.svg')
				}
			},
			{
				path: '/tabbar/my',
				name: 'My',
				component: () => import('@/views/my'),
				meta: { name: '我的', tabShow: true, routerBack: false },
				icon: {
					active: require('@/assets/Tabbar/acmy.svg'),
					inactive: require('@/assets/Tabbar/my.svg')
				}
			}
		]
	},
]

export default tabbar
